import jsPDF from 'jspdf';
import { PDF_COLORS } from '../config/colors';
import { PDF_FONTS, PDF_LAYOUT } from '../config/fonts';

export class FooterComponent {
  private pdf: jsPDF;

  constructor(pdf: jsPDF) {
    this.pdf = pdf;
  }

  addFooter(userDetails?: any, pageNumber?: number): void {
    const currentPageNumber = pageNumber || this.pdf.getCurrentPageInfo().pageNumber;
    const pageHeight = this.pdf.internal.pageSize.getHeight();
    const pageWidth = this.pdf.internal.pageSize.getWidth();
    
    // Save current state
    const currentFontSize = this.pdf.getFontSize();
    const currentTextColor = this.pdf.getTextColor();
    
    // Footer background
    this.pdf.setFillColor(...PDF_COLORS.background.light);
    this.pdf.rect(0, pageHeight - 20, pageWidth, 20, 'F');
    
    // Footer text
    this.pdf.setFontSize(PDF_FONTS.size.tiny);
    this.pdf.setTextColor(...PDF_COLORS.text.light);
    
    // Left side - Document info
    this.pdf.text(
      'Export Readiness Assessment Report',
      PDF_LAYOUT.margins.left,
      pageHeight - 8
    );
    
    // Center - Page number (only for content pages, starting from page 2)
    if (currentPageNumber > 1) {
      this.pdf.text(
        `Page ${currentPageNumber - 1}`,
        pageWidth / 2,
        pageHeight - 8,
        { align: 'center' }
      );
    }
    
    // Right side - LSEM branding
    this.pdf.setTextColor(...PDF_COLORS.primary);
    this.pdf.setFont(PDF_FONTS.primary, 'bold');
    this.pdf.text(
      'Lagos School of Export Management',
      pageWidth - PDF_LAYOUT.margins.right,
      pageHeight - 8,
      { align: 'right' }
    );
    
    // Restore state
    this.pdf.setFontSize(currentFontSize);
    this.pdf.setTextColor(currentTextColor);
  }

  // Remove the watermark method since it affects readability
  addWatermark(): void {
    // Watermark removed for better readability
    return;
  }
}